import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ActionLink extends Component {
  render() {
    return (
      <span className="action-link with-arrow">
        <Link {...this.props}>
          {this.props.children}
          <span className="arrow-right">&nbsp;</span>
        </Link>
      </span>
    );
  }
}

export default ActionLink;



// WEBPACK FOOTER //
// ./src/common/components/ActionLink/ActionLink.jsx